enum ApplicationReviewType {
  Basic = 'Basic',
  Standard = 'Standard',
}

export default ApplicationReviewType;
